const card = "_275chkk0l3";
const textContainer = "_275t1u4lkiy";
const heading = "_275hm525br";
const bottomWrapper = "_275b1cjyux6";
const subHeading = "_275s1pevhwy";
const link = "_275l1i5mima";
const linkIcon = "_275ltfjn26";
const throbber = "_275t1w0b2e5";

export { bottomWrapper, card, heading, link, linkIcon, subHeading, textContainer, throbber };
import "./_favourite-card.style.linaria.module.css";
//# sourceMappingURL=_favourite-card.style.js.map
